import React from 'react';

const SkillIcon = ({ icon, name }) => (
  <img className="stat-icon" src={require(`../../assets/icons/${icon}-icon.png`)} alt={name} />
);

export default SkillIcon;



// WEBPACK FOOTER //
// ./src/components/SkillIcon.js